/**
 * PendingActivationView — signed-in but not yet activated by an admin.
 * The UAT gate: no Beacon features until the admin flips them to Active.
 */
export default function PendingActivationView({ authUser, onSignOut }) {
  return (
    <div className="beacon-pending" data-testid="pending-activation">
      <div className="beacon-pending-card">
        <div className="beacon-tiny-label">ACCOUNT PENDING</div>
        <h1 className="beacon-pending-title">
          Thanks for signing up{authUser?.name ? `, ${authUser.name.split(" ")[0]}` : ""}.
        </h1>
        <p className="beacon-pending-body">
          Your account is awaiting activation. You&rsquo;ll get access to
          Beacon as soon as an administrator approves it — no action needed
          from you.
        </p>
        <div className="beacon-pending-meta" data-testid="pending-email">
          Signed in as <strong>{authUser?.email}</strong>
        </div>
        <div className="beacon-pending-actions">
          <a className="beacon-secondary-btn" href="/pricing"
            data-testid="pending-pricing-link">View pricing</a>
          <button type="button" className="beacon-secondary-btn"
            data-testid="pending-signout"
            onClick={onSignOut}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
